// extracted by mini-css-extract-plugin
export var red = "dataForm-module--red--7990c";
export var requiredMessage = "dataForm-module--requiredMessage--e47ab";
export var wrapper = "dataForm-module--wrapper--0fce8";